import React from 'react';

const Closings = props => {
    return <div>
        <h1>Closings</h1>
    </div>
}

export default Closings;